var map = {
	"./aparthotelclub/ic_tag_country.png": 36903,
	"./beachful/ic_tag_country.png": 70516,
	"./castlepedia/ic_tag_country.png": 21663,
	"./cocktayl/ic_tag_country.png": 17806,
	"./ic_tag_country.png": 77014,
	"./luxresortclub/ic_tag_country.png": 79506,
	"./parkful/ic_tag_country.png": 32766,
	"./prefabworld/ic_tag_country.png": 14987,
	"./rooftopclub/ic_tag_country.png": 49914,
	"./spaclub/ic_tag_country.png": 80584,
	"./worldcasino/ic_tag_country.png": 98460,
	"./zoopedia/ic_tag_country.png": 87407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17229;